import React, { useEffect, useState } from "react";
import PageTitle from "../components/PageTitle";
import PageWrapper from "../layouts/Index";
import { fbnSumitPrequalForm, fetchAllPartners, getNetworkProviders,} from "../services/PrequalificationService";
import useLoader from "../customHooks/useLoader";
import { SpinnerIcon } from "../utils/Loader";
import Alerts from "../components/Alerts";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { updatePrecustomer } from "../redux/features/precustomers/PrecustomerSlice";
import { splitAndCapitalize } from "../utils/format";
import "react-toastify/dist/ReactToastify.css";
import useCustomAlert from "../components/Alert2";
import Box from '@mui/material/Box';
import { Form, Formik } from "formik";
import {fbnPrequalFormSchema} from "../utils/formValidationSchema";
import CustomInputField from "../components/CustomInputField";
import CustomSelectField from "../components/CustomSelectField";

const FBNPrequalForm = () => {

const [errMsg, setErrMsg] = useState("");
const [loader, showLoader] = useLoader(SpinnerIcon);
const [loader2, showLoader2] = useLoader(SpinnerIcon);
const navigate = useNavigate();
const [networkProviders, setNetworkProviders] = useState([]);
const [partners, setPartners] = useState([]);
const [userTypePre, setUserTypePre] = useState(null);
const dispatch = useDispatch();
const customAlert = useCustomAlert();
const loggedInUser = useSelector((state) => state?.user?.user);
const [fetchingPartners, setFetchingPartners] = useState([]);
const storePrecustomer = useSelector((state) => state?.precustomer?.precustomerData);
const {msisdn} =  useSelector((state) => state?.precustomer?.precustomerData.precustomer);
// NB: i am filtering only FBN from the partners because we currently have FBN as the only corporate onboard partner, when we have more we'll remove it. (just to avoid confusing the reps) .
const filteredFBNPartners = partners?.filter((partner) => Number(partner?.id) === 407)|| [];

useEffect(() => {
    // Get type from local storage if it exists
    let userInStorage = localStorage.getItem("allAboard-userType");
    const userTypeStorage = userInStorage ? JSON.parse(userInStorage) : null;
    setUserTypePre(userTypeStorage);

    const fetchData = async () => {
        try {
        showLoader2(true);
        setFetchingPartners(true);
        // Fetch network providers
        const result = await getNetworkProviders();

        // Update network provider state
        setNetworkProviders(result?.data);
        showLoader2(false);

        // Fetch partners
        const result2 = await fetchAllPartners();

        // Update network provider state
        setPartners(result2?.data);
        setFetchingPartners(false);
        } catch (error) {
        // Handle errors if necessary
        showLoader2(false);
        setErrMsg("Error fetching network providers/partners...!");
        }
    };

    fetchData();
}, []);

const initialValues = {
    telco: "",
    partnerid: filteredFBNPartners[0]?.id || "",
    bvn: "",
    nin: "",
    msisdn: msisdn || "",
    email: "",
}

const handleSubmit = async (values) => {
    setErrMsg("");
    showLoader(true);

    const userPayload = {
      telcoName: Number(values.telco),
      pre_customer_id: 0,
      nin: String(values.nin),
      bvn: String(values.bvn),
      msisdn: String(values.msisdn),
      email: String(values.email),
      customertype: userTypePre?.customerType,
      partnerid: Number(values.partnerid),
      rep_id: loggedInUser?.id,
      customertype_sub: userTypePre?.customerType_sub,
      is_Self_Onboard: false,
    };
    const res = await fbnSumitPrequalForm(userPayload);
    console.log("res", res);
    if (res.status || res?.payload?.status) {
        setTimeout(() => {
            const precustomerId =
                res.data?.precustomerId ||
                res.data?.precustomerid ||
                res.data?.precustomerinfo?.precustomerid;
            dispatch(
                updatePrecustomer({
                    precustomer: { 
                        ...storePrecustomer?.precustomer,
                        precustomerId: precustomerId,
                        accountNumber: values.bvn ,
                        idNumber: values.nin,
                        email: values.email,
                    },
                    onboarding_status:"validate-otp",
                })
            );
            navigate(`/validate-otp`);
        }, 1000);
        customAlert.showToast("success", `${res?.message || res?.payload?.message || res?.title}`||  "Operation Successful...!");
    
    }else{
        customAlert.showToast("error",  `${res?.message || res?.payload?.message || res?.title}`||  "Operation Failed...!");
        setErrMsg(`${res?.message || res?.payload?.message || res?.title}` ||  "Operation Failed...!");
    }
    showLoader(false);
}


  return (
     <PageWrapper>
      <PageTitle
        title={`Prequalification Form`}
      />
      <Box sx={{ width: '100%', typography: 'body1' }}>
        <div className="row">
            <div className="col-xl-6 col-lg-8 col-md-12">
            <div className="card">
                {/* Alert - starts  */}
                {errMsg && (
                <Alerts
                    alertType={"danger"}
                    title={`Prequalification Failed`}
                    message={errMsg}
                />
                )}

                <div className="card-header">
                <div className="card-title">Prequalify Customer</div>
                </div>
                <div className="card-body">
                    <Formik
                    initialValues={initialValues}
                    validationSchema={fbnPrequalFormSchema}
                    onSubmit={(values) => handleSubmit(values)}
                    enableReinitialize
                    >
                    {({
                        errors,
                        touched,
                        values,
                        handleBlur,
                        handleChange,
                        isSubmitting,
                        setFieldValue,
                        handleSubmit,
                    }) => (
                        <Form>
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <CustomSelectField
                                        label="Select Network Provider:"
                                        placeholder="Select Network Provider"
                                        name="telco"
                                        onChange={handleChange}
                                        value={values.telco || ""} 
                                        onBlur={handleBlur}
                                        error={errors.telco}
                                        touched={touched.telco}
                                    >
                                        <option value="" selected disabled>
                                        Choose
                                        </option>
                                        {loader2 ? (
                                        <option value="" disabled>
                                            Loading...
                                        </option>
                                        ) : (
                                        ""
                                        )}
                                        {networkProviders?.length > 0
                                        ? networkProviders?.map((network, index) => (
                                            <option key={index} value={network?.value}>
                                                {splitAndCapitalize(network?.name)}
                                            </option>
                                            ))
                                        : ""}
                                    </CustomSelectField>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <CustomSelectField
                                        label="Select Partner:"
                                        placeholder="Select Partner"
                                        name="partnerid"
                                        onChange={(e) => setFieldValue("partnerid", e.target.value)}
                                        value={values.partnerid || ""} 
                                        onBlur={handleBlur}
                                        error={errors.partnerid}
                                        touched={touched.partnerid}
                                    >
                                        <option value="" selected disabled>
                                            Choose
                                        </option>
                                        {fetchingPartners ? (
                                            <option value="" disabled>
                                            Loading...
                                            </option>
                                        ): filteredFBNPartners?.length > 0 ? (
                                            filteredFBNPartners?.map((partner, index) => (
                                            <option key={index} value={partner?.id}>
                                                {partner?.companyName}
                                            </option>
                                            ))
                                        ) : (
                                            "No partners retrieved..."
                                        )}
                                    </CustomSelectField>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-md-6 col-sm-12">
                                    <CustomInputField
                                        label="Enter Account Number"
                                        placeholder="000-000-000-00"
                                        name="bvn"
                                        type="tel"
                                        value={values.bvn}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        error={errors.bvn}
                                        touched={touched.bvn}
                                    />
                                </div>
                                <div className="col-md-6 col-sm-12">
                                    <CustomInputField
                                        label="Enter NIN"
                                        placeholder="000-000-000-00"
                                        name="nin"
                                        type="tel"
                                        value={values.nin}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        error={errors.nin}
                                        touched={touched.nin}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                    <CustomInputField
                                        label="Phone Number"
                                        placeholder="eg. 7xxxxxxxx"
                                        name="msisdn"
                                        type="tel"
                                        value={values.msisdn}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        error={errors.msisdn}
                                        touched={touched.msisdn}
                                        readOnly={msisdn? true : false}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                    <CustomInputField
                                        label="Email"
                                        placeholder="eg. john34@gmail.com"
                                        name="email"
                                        type="email"
                                        value={values.email}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        error={errors.email}
                                        touched={touched.email}
                                    />
                                </div>
                            </div>
                            <div className="row mt-2">
                            <div className="col-sm-12">
                              <button
                                type="submit"
                                className="btn btn-primary btn-lg"
                                disabled={loader}
                              >
                                Prequalify {loader}
                              </button>
                            </div>
                          </div>
                        </Form>
                    )}
                    </Formik>
                </div>
            </div>
            </div>
        </div>
      </Box>
    </PageWrapper>
  )
}

export default FBNPrequalForm